import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
} from "@material-ui/core";

interface IRecord {
  id: number;
  description: string;
  type: string;
  status: string;
  processingStatus: string;
}

interface ITableResultCsvFileUpload {
  records: IRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
});

const TableResultConfirmCommercialDocuments = ({
  records,
}: ITableResultCsvFileUpload) => {
  const classes = useStyles();
  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Commercial Document Id</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Processing Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record: IRecord, key: number) => {
            return (
              <TableRow key={`row-${key}`}>
                <TableCell>{record.id}</TableCell>
                <TableCell>{record.type}</TableCell>
                <TableCell>{record.description}</TableCell>
                <TableCell>{record.status}</TableCell>
                <TableCell>{record.processingStatus}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultConfirmCommercialDocuments;
